export enum PollHeroOptions {
  OPTION1 = 'option1',
  OPTION2 = 'option2',
  OPTION3 = 'option3',
}
